var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3217 14.7686V15.9949C29.3201 18.8691 28.3893 21.6659 26.6684 23.968C24.9474 26.27 22.5284 27.9541 19.7721 28.7691C17.0158 29.584 14.0699 29.4862 11.3737 28.4901C8.6776 27.494 6.37568 25.6531 4.81128 23.2419C3.24689 20.8306 2.50384 17.9783 2.69296 15.1103C2.88207 12.2423 3.99322 9.51219 5.86069 7.32726C7.72815 5.14233 10.2519 3.6196 13.0555 2.98616C15.859 2.35273 18.7923 2.64253 21.4177 3.81236",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3236 5.33142L15.9947 18.6736L11.9961 14.6749",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e57d86c2009f3c2bdfcd5a9204fc957b.svg";
export { ForwardRef as ReactComponent };